export default __webpack_public_path__ + "static/media/Portfolio.d15a7b0b.png";